import { put, takeLatest } from 'redux-saga/effects';
import {
  GET_DATA_FEED_FORM_CHANGE,
  GET_DATA_FEEDS_STATUS_SUCCESS,
  GET_DATA_FEEDS_STATUS_FAILURE,
} from '../../../../../store/actionTypes';

/**
 * Saga to get datafeed Data status.
 */
export function* getDataFeedStatusSaga(action: any) {
  try {
    const data = action;
    yield put({ type: GET_DATA_FEEDS_STATUS_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_DATA_FEEDS_STATUS_FAILURE, error });
  }
}

export function* waitForDataFeedStatus() {
  yield takeLatest(GET_DATA_FEED_FORM_CHANGE, getDataFeedStatusSaga);
}
